import Vue from 'vue'
import router from '@/router'
import store from '@/store/'
import { ACCESS_TOKEN, USER_INFO, USER_ROLE } from "@/store/mutation-types";
import BannerLayout from './layouts/BannerLayout'
import CmsLayout from './layouts/CmsLayout'
import CmsSideLayout from './layouts/CmsSideLayout'
import HomeLayout from './layouts/HomeLayout'
import WideLayout from './layouts/WideLayout'
import BlankLayout from './layouts/BlankLayout'
import UserLayout from './layouts/UserLayout'
import { getAction } from "@/api/manage";
import { changeURLStatic } from '@/utils/util'

const whiteList = ['/user/login', '/home'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  console.log(Vue.ls.get(ACCESS_TOKEN));
  if (Vue.ls.get(ACCESS_TOKEN)) {
    next()
  } else {
    if (whiteList.indexOf(to.path) == -1) {
      next()
      // next({ path: '/user/login', query: { redirect: to.fullPath, role: Vue.ls.get(USER_ROLE) } })
    } else {
      next()
    }
  }
})

let tenantConfig = store.getters.tenantInfo

/**
 * 基础路由
 * @type { *[] }
 */
const RouterMap = [
  {
    path: '/',
    component: HomeLayout,
    redirect: tenantConfig && tenantConfig.home || '/index',
    hidden: true,
    children: [
      {
        path: '/index',
        name: 'index',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/Index')
      },
      {
        path: '/home',
        name: 'home',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/Index2'),
      }
    ]
  },
  {
    path: '/school',
    component: CmsLayout,
    redirect: '/school/list',
    children: [
      {
        path: 'list',
        name: 'list',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/SchoolList')
      },
      {
        path: 'detail',
        name: 'detail',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/SchoolDetail')
      },
    ]
  },
  {
    path: '/cms',
    component: CmsLayout,
    redirect: '/cms/list',
    children: [
      {
        path: 'index',
        name: 'cmsIndex',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/CmsListAuto')
      },
      {
        path: 'list',
        name: 'cmsList',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/CmsList')
      },
      {
        path: 'detail',
        name: 'cmsDetail',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/CmsDetail')
      },
    ]
  },
  {
    path: '/work',
    component: CmsLayout,
    redirect: '/work/list',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/Home')
      },
      {
        path: 'list',
        name: 'list',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/WorkList')
      },
      {
        path: 'detail',
        name: 'detail',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/WorkDetail')
      },

      {
        path: 'mdEditor',
        name: 'mdEditor',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/MarkdownEditor')
      },
      {
        path: 'mdView',
        name: 'mdView',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/MarkdownView')

      }
    ]
  },
  {
    path: '/course',
    name: 'course',
    redirect: '/course/index',
    component: CmsLayout,
    children: [
      {
        path: 'index',
        name: 'courseIndex',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/CourseList')
      },
      {
        path: 'detail',
        name: 'courseDetail',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/CourseDetail')
      },
    ]
  },
  {
    path: '/paper',
    name: 'paper',
    redirect: '/paper/list',
    component: CmsSideLayout,
    children: [
      {
        path: 'list',
        name: 'paperList',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/PaperList')
      },
    ]
  },
  {
    path: '/friend',
    component: CmsLayout,
    redirect: '/friend/detail',
    children: [
      {
        path: 'detail',
        name: 'friendDetail',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/FriendDetail')

      }
    ]
  },
    {
    path: '/cert',
    component: BlankLayout,
    redirect: '/cert/query',
    hidden: true,
    children: [
      {
        path: '/cert/query',
        name: 'certQuery',
        component: () => import(/* webpackChunkName: "aice" */ './views/CertQuery')
      },
      // {
      //   path: '/cert/score',
      //   name: 'scoreQuery',
      //   component: () => import(/* webpackChunkName: "aice" */ './views/ScoreQuery')
      // },
      {
        path: '/cert/studentReport',
        name: 'studentReport',
        component: () => import(/* webpackChunkName: "aice" */ './views/StudentCategoryReport')
      },
      {
        path: '/cert/schoolReport',
        name: 'schoolReport',
        component: () => import(/* webpackChunkName: "aice" */ './views/SchoolCategoryReport')
      }
    ]
  },
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/index',
    children: [
      {
        path: 'index',
        name: 'userIndex',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/user/Index')
      },
      {
        path: 'index',
        name: 'teacherIndex',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/teacher/TeacherReport')
      },
      {
        path: 'course',
        name: 'userCourse',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/user/Course')
      },
      {
        path: 'additionalWork',
        name: 'userAdditionWork',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/user/AdditionalWork')
      },
      {
        path: 'event',
        name: 'userEvent',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/user/Event')
      },
      {
        path: 'order',
        name: 'userOrder',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/user/Order')
      },
      {
        path: 'info',
        name: 'userInfo',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/user/Info')
      },
      {
        path: 'setting',
        name: 'userSetting',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/user/Setting')
      },
      {
        path: 'work',
        name: 'userWork',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/user/Work')
      },
      {
        path: 'collect',
        name: 'collect',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/user/Collect')
      },
      {
        path: 'attention',
        name: 'attention',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/user/Attention')
      },
      {
        path: 'question',
        name: 'userQuestion',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/user/Question')
      },
      {
        path: 'myPaper',
        name: 'myPaper',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/user/MyPaper')
      },
      {
        path: 'myPaperAnswer',
        name: 'myPaperAnswer',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/user/MyPaperAnswer')
      },
      {
        path: 'userPaper',
        name: 'userPaper',
        component: () => import(/* webpackChunkName: "mooccode" */ '@/components/exam/UserPaperPreview')
      },
      {
        path: 'Vip',
        name: 'Vip',
        component: () => import(/* webpackChunkName: "aice" */ './views/user/Vip')
      }
    ]
  },
  {
    path: '/teacher',
    component: UserLayout,
    redirect: '/teacher/index',
    children: [
      {
        path: 'index',
        name: 'teacherIndex',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/teacher/TeacherReport')
      },
    ]
  },
  {
    path: '/event',
    name: 'event',
    redirect: '/event/list',
    component: CmsLayout,
    children:[
      {
        path: 'list',
        name: 'eventList',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/EventList')
      },
      {
        path: 'detail',
        name: 'eventDetail',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/EventDetail')
      },
      {
        path: 'apply',
        name: 'eventApply',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/EventApply')
      },
      {
        path: 'desc',
        name: 'eventDesc',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/EventDesc')
      },
      {
        path: 'trends',
        name: 'eventTrends',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/EventTrends')
      },
    ]
  },
  {
    path: '/activity',
    name: 'activity',
    redirect: '/activity/list',
    component: CmsLayout,
    children:[
      {
        path: 'list',
        name: 'activityList',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/ActivityList')
      },
      {
        path: 'detail',
        name: 'activityDetail',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/ActivityDetail')
      },
    ]
  },
  {
    path: '/',
    component: WideLayout,
    // redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/Login')
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/Register')
      },
      {
        path: 'find',
        name: 'find',
        component: () => import(/* webpackChunkName: "mooccode" */ './views/Find')
      }
    ]
  },
  {
    path: '/examine',
    component:()=>import(/* webpackChunkName: "mooccode" */ '@/components/exam/Examine')
  },
]
export default RouterMap